import {
    SHOW_MODAL,
    HIDE_MODAL,
    SHOW_SHARE_MODAL,
    HIDE_SHARE_MODAL,
    SHOW_INTERVIEW_EVALUATION_MODAL,
    HIDE_INTERVIEW_EVALUATION_MODAL,
    LOAD_RESUME_INFO,
    LOAD_INFO_START,
    LOAD_INFO_DONE,
    SHOW_MODAL_LOADING,
    HIDE_MODAL_LOADING,
    DOWNLOAD_RESUME_START,
    DOWNLOAD_RESUME_DONE,
    GET_EVALUATION,
    GET_EVALUATION_ID,
    RESUME_INFORMATION,
    HIDE_BACKGROUNDSURVEY_MODAL,
    SHOW_BACKGROUNDSURVEY_MODAL,
    RESUME_INFO,
    FILL_LOADING,
    SHOW_QRCODE_LINKMODAL,
    HIDE_QRCODE_LINKMODAL,
    INTERVIEW_INFO,
    SCORES,
    SUMMARY,
    SHOW_RESUME_EDIT_MODEL,
    HIDE_RESUME_EDIT_MODEL,
    SHOW_ECHARTS_STATUS,
    HIDE_ECHARTS_STATUS,
    TEMP_BACICINFO,
    TEMP_INTENTION,
    TEMP_ASSESSMENT,
    TEMP_EDUCLIST,
    TEMP_PROJECT_LIST,
    TEMP_WORK_LIST,
    TEMP_LAN_LIST,
    TEMP_TRAIN_LIST,
    TEMP_CERT_LIST,
    TEMP_OTHER_LIST,
    TEMP_BORNDATA,
    TYPE,
    GET_EVALUATION_INTERVIEWS,
    TEMP_ADVAR,
    TEMP_ADVAR_FILEPATH,
    
} from 'constants/resume-info';

const initialState = {
   modalVisible: false,
   shareModalVisible: false,
   evaluationModalVisible: false,
   currentStage:{},
   resumeInfo: {},
   resumeData: {},
   evaluationData: {},
   isModalLoading: false,
   isDownLoading: false,
   evaluation:{},//评估表
   evaluationid:"",//评估表ID
   resumeUrl:{},
   backSurveyVisible: false,
   resumeInformation: {},
   isLoading:true,
   shareLinkModalVisible:false,
   companyInfo: {},
   intrerviewInfo:{},
   scores:[],//分数
   summary:'',
   resumeEditModel:false,
   echarts:false,//控制echarts的显示和隐藏
   dignityList:[],
   tempResumeInfo:{},
   tempIntention:{},
   tempAssessment:{},
   tempEducList:[],
   tempProjectlist:[],
   tempWorkList:[],
   tempLanlist:[],
   tempTrainlist:[],
   tempCertlist:[],
   tempOtherlist:[],
   type:0,
   evaluationInterviews:[],
   tempborndate:'',
   tempAdvar:'',
   tempAdvarFilepath:''
//    dispatch({...TEMP_ADVAR_FILEPATH,tempAdvarFilepath:res.data.result.headimg});

};

export default function resume(state = initialState,actions){
    switch(actions.type){
        case 0 :
         return {...state,type:actions.type};
         case 4 :
            return {...state,type:actions.type};
         case 5 :
             return {...state,type:actions.type};  
        case GET_EVALUATION_INTERVIEWS:
             return {...state,evaluationInterviews:actions.evaluationInterviews};  
        case  TEMP_BORNDATA:
            return {...state,tempborndate:actions.tempborndate};
        case TEMP_OTHER_LIST:
             return {...state,tempOtherlist:actions.tempOtherlist};   
        case  TEMP_CERT_LIST:
              return {...state,tempCertlist:actions.tempCertlist};
        case TEMP_TRAIN_LIST:
              return {...state,tempTrainlist:actions.tempTrainlist};
        case TEMP_LAN_LIST:
            return {...state,tempLanlist:actions.tempLanlist};
        case TEMP_WORK_LIST:
            return {...state,tempWorkList:actions.tempWorklist};
        case TEMP_PROJECT_LIST:
            return {...state,tempProjectlist:actions.tempProjectlist};
        case TEMP_EDUCLIST:
            return {...state,tempEducList:actions.tempEducList};
        case TEMP_ASSESSMENT:
            return {...state,tempAssessment:actions.tempAssessment};
        case TEMP_INTENTION:
            return {...state,tempIntention:actions.tempIntention};
        case SHOW_ECHARTS_STATUS:
        case TEMP_BACICINFO:
            return {...state,tempResumeInfo:actions.tempResumeInfo};
        case SHOW_ECHARTS_STATUS:
            return {...state,echarts:true}; 
        case HIDE_ECHARTS_STATUS:
            return {...state,echarts:false}; 
        case  TEMP_ADVAR:
            return {...state,tempAdvar:actions.tempAdvar}; 
        case  TEMP_ADVAR_FILEPATH:
            return {...state,tempAdvarFilepath:actions.tempAdvarFilepath}; 
        case  SCORES:
            return {...state,scores:actions.scores,dignityList:actions.dignityList};
        case  SUMMARY:
            return {...state,summary:actions.summary};  
        case  SHOW_RESUME_EDIT_MODEL:
            return {...state,resumeEditModel:true};
        case  HIDE_RESUME_EDIT_MODEL:
            return {...state,resumeEditModel:false};
        case INTERVIEW_INFO:
            return {...state,intrerviewInfo:actions.interviewInfo};
        case SHOW_MODAL:
            return {...state,modalVisible:true,currentStage:actions.currentStage};
        case HIDE_MODAL:
            return {...state,modalVisible:false};
        case SHOW_SHARE_MODAL:
            return {...state,shareModalVisible:true,resumeData:actions.resumeData};
        case RESUME_INFORMATION:
            return {...state,resumeUrl:actions.resumeUrl};
        case GET_EVALUATION:
            return {...state,evaluation:actions.evaluation};
        case GET_EVALUATION_ID:
            return {...state,evaluationid:actions.evaluationid};
        case HIDE_SHARE_MODAL:
            return {...state,shareModalVisible:false};
        case SHOW_INTERVIEW_EVALUATION_MODAL:
            return {...state,evaluationModalVisible:true,evaluationData:actions.evaluationData};
        case HIDE_INTERVIEW_EVALUATION_MODAL:
            return {...state,evaluationModalVisible:false};
        case LOAD_RESUME_INFO:
            return {...state,resumeInfo:actions.resumeInfo};
        case LOAD_INFO_START:
            return {...state,isInfoLoading:true};
        case LOAD_INFO_DONE:
            return {...state,isInfoLoading: false};
        case SHOW_MODAL_LOADING:
            return {...state,isModalLoading: true};
        case HIDE_MODAL_LOADING:
            return {...state,isModalLoading: false};
        case DOWNLOAD_RESUME_START:
            return {...state,isDownLoading: true};
        case DOWNLOAD_RESUME_DONE:
            return {...state,isDownLoading: false};
        case SHOW_BACKGROUNDSURVEY_MODAL:
            return {...state,backSurveyVisible:true};
        case HIDE_BACKGROUNDSURVEY_MODAL:
            return {...state,backSurveyVisible:false};
        case RESUME_INFO:
            return {...state,resumeInformation:actions.resumeInformation};
        case FILL_LOADING:
            return {...state,isLoading: false};
        case SHOW_QRCODE_LINKMODAL:
            return {...state,shareLinkModalVisible: true,companyInfo:actions.companyInfo}
        case HIDE_QRCODE_LINKMODAL:
            return {...state,shareLinkModalVisible: false}
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducer/resume-info.js